<template>
  <aside v-if="next" class="next-up">
    <p class="next-up__label">{{ next.label }}</p>
    <p class="next-up__text">{{ next.text }}</p>
    <p v-if="next.timer" class="next-up__timer">With a {{ formatSeconds(next.timer.seconds) }} timer · {{ next.timer.label }}</p>
  </aside>
</template>

<script>
// A quiet preview of the step after this one, so the cook can see what is
// coming while their hands are busy. It sits UNDER the Ask box on purpose:
// text directly above a text box is what iOS reads to decide the box is a
// card field (see "The word pan" in CLAUDE.md).
import { formatSeconds } from '../utils/timers.js';

export default {
  name: 'NextUp',
  props: { next: { type: Object, default: null } },
  setup () {
    return { formatSeconds };
  }
};
</script>

<style scoped>
.next-up { border: 1px dashed var(--line); border-radius: var(--radius); padding: 0.6rem 0.9rem; color: var(--muted); }
.next-up__label { font-size: 0.75rem; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; margin: 0 0 0.2rem; }
.next-up__text { margin: 0; line-height: 1.4; }
.next-up__timer { font-size: 0.85rem; margin: 0.3rem 0 0; }
</style>
